import {
  call,
  fork,
  put,
  select,
  takeLatest,
  takeLeading,
  takeEvery,
} from 'redux-saga/effects'
import * as T from '../api/constants'
import {
  success,
} from 'slices/globalSlice'

import { boiler } from './sagaHelpers'

function* getPayrollAccounts({ type, data }) {
  const results = yield call(boiler, 'getPayrollAccounts', { type }, data)
  if (results.status === 'success') yield put(success({ typeLoading: type, payrollAccounts: results.data }))
}

export function* payrollSagas() {
  yield takeLeading(T.GET_PAYROLL_ACCOUNTS, getPayrollAccounts)
}